<template>
  <router-view />
</template>

<script>
import config from '@/utils/config';
export default {
  name: 'admin',
  data() {
    return {};
  },
  mounted() {
    if (config.ACCESS_TOKEN) {
      this.$store.dispatch('tags/fetch', { pageSize: 1000 });
    }
  },
};
</script>
